// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => ("static/css/" + chunkId + "." + {"218":"bc8541f4","964":"5079979d"}[chunkId] + ".chunk.css");